<template>
  <div class="sr-d-input">
    <div class="row-box">
      <div class="left-col" :style="{ width: introWidth + 'px' }">引言：</div>
      <div class="right-col">
        <SrTextarea
        v-model.trim="intro"
        :item="introProc"
        ></SrTextarea>
      </div>
    </div>
    <div class="row-box" v-for="(item, index) in list" :key="'r_'+index">
      <div class="left-col" :style="{ width: introWidth + 'px' }">
        <SrInput v-model.trim="item.label" :item="item.labelConfig"></SrInput>
      </div>
      <div class="right-col">
        <SrTextarea v-model.trim="item.text" :item="item.textConfig"></SrTextarea>
      </div>
    </div>
    <div class="add-btn" @click="addRow">
      <i class="el-icon-plus"></i> <span>添加</span>
    </div>
  </div>
</template>

<!--
  功能：机构职能
  钟宝琴
  时间：2021年10月15日
  版本：v1.0
-->
<script>
  export default {
    name: "SrDInput",
    components: {},
    props: {
      info: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    watch: {
      'info': {
        handler() {
          this.initVal()
        }
      }
    },
    data() {
      return {
        introWidth: 192,
        intro: '',
        list: [],
        introProc: {
          placeholder: "请输入引言",
          bind: "intro",
          col: 24,
          maxlength: 100
        }
      }
    },
    mounted() {
      this.initVal()
    },
    methods: {
      initVal() {
        if (this.info) {
          let { introWidth, intro, list } = this.info
          if (introWidth) {
            this.introWidth = introWidth
          }
          if (intro) {
            this.intro = intro
          } else {
            this.intro = ''
          }
          if (list && list.length > 0) {
            this.list = list
          } else {
            this.list = []
          }
        }
      },
      getVal() {
        let res = []
        if (this.list && this.list.length > 0) {
          this.list.map(item => {
            res.push({
              label: item.label,
              text: item.text
            })
          })
        }
        return {
          intro: this.intro,
          list: res
        }
      },
      addRow() {
        let newRow = {
          label: '',
          labelConfig: {
            placeholder: '请输入新添标题',
            maxLength: 10
          },
          text: '',
          textConfig: {
            placeholder: '请输入新添内容',
            col: 24,
            maxlength: 100
          }
        }
        this.list.push(newRow)
      },
      change(value) {
        this.$emit("change", value);
      },
      callFn(btn, $event) {
        //操作事件
        if (btn.method && btn.method.constructor == Function) {
          // 兼容以前，扩展传入fn方式
          btn.method(btn, this.form);
          return;
        }
        let sum = 0;
        let obj = this.getDeepMethod(this.$parent, btn.method, sum, 10);
        if (obj.parent && obj.method) {
          obj.method.call(obj.parent, $event, this.form, this.config);
        }
      },
      // 递归找method
      getDeepMethod(parent, method, sum, limit) {
        sum++;
        if (!parent) {
          return {};
        } else if (sum == limit) {
          return {};
        } else if (parent[method]) {
          return {
            parent,
            method: parent[method],
          };
        } else {
          return this.getDeepMethod(parent.$parent, method);
        }
      },
    }
  };
</script>



// WEBPACK FOOTER //
// packages/SrDInput/index.vue